export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Naomi_eACCESO.9f6adba3.jpg";